import React, { useState, useMemo } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import moment from "moment-timezone";

const ScheduleModal = ({
  show,
  onHide,
  cronInputs,
  setCronInputs,
  onSave,
  resetCron,
}) => {
  const [showConfirm, setShowConfirm] = useState(false);

  // Get system's local timezone abbreviation
  const localTimezoneAbbr = useMemo(() => {
    try {
      return moment.tz(moment.tz.guess()).zoneAbbr();
    } catch {
      return "UTC";
    }
  }, []);

  const handleResetClick = () => {
    setShowConfirm(true); // show confirmation modal
  };

  const handleConfirmReset = () => {
    resetCron(); // perform reset action
    setShowConfirm(false); // close confirmation modal
    onHide();
  };

  return (
    <>
      {/* Main Schedule Modal */}
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Schedule</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Time</Form.Label>
              <div className="d-flex gap-2">
                <Form.Control
                  type="time"
                  value={cronInputs.time}
                  onChange={(e) =>
                    setCronInputs({ ...cronInputs, time: e.target.value })
                  }
                  style={{ flex: 1 }}
                />
                <Form.Select
                  value={cronInputs.timezone || "UTC"}
                  onChange={(e) =>
                    setCronInputs({ ...cronInputs, timezone: e.target.value })
                  }
                  style={{ maxWidth: 150 }}
                >
                  <option value="UTC">UTC</option>
                  <option value={localTimezoneAbbr}>
                    Local ({localTimezoneAbbr})
                  </option>
                </Form.Select>
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Frequency</Form.Label>
              <Form.Select
                value={cronInputs.frequency}
                onChange={(e) =>
                  setCronInputs({ ...cronInputs, frequency: e.target.value })
                }
              >
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
              </Form.Select>
            </Form.Group>
            {cronInputs.frequency === "weekly" && (
              <Form.Group className="mb-3">
                <Form.Label>Days</Form.Label>
                <div className="d-flex flex-wrap gap-2">
                  {[0, 1, 2, 3, 4, 5, 6].map((d) => (
                    <Form.Check
                      key={d}
                      type="checkbox"
                      label={
                        ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][d]
                      }
                      checked={cronInputs.days.includes(d)}
                      onChange={() => {
                        let days = [...cronInputs.days];
                        if (days.includes(d)) {
                          days = days.filter((day) => day !== d);
                        } else {
                          days.push(d);
                        }
                        setCronInputs({ ...cronInputs, days });
                      }}
                    />
                  ))}
                </div>
              </Form.Group>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button variant="danger" onClick={handleResetClick}>
            Remove
          </Button>
          <Button variant="success" onClick={onSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Confirmation Modal */}
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Remove</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          This action will remove the schedule. Are you sure you want to
          proceed?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirm(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirmReset}>
            Yes, Remove
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ScheduleModal;
